import { action, observable } from 'mobx';


class FailedRequests {
  @observable retryTimeout = 15000;
  @observable remainingTime = null;
  retryResolve = null;
  retryTimeoutId = -1;
  retryPromise = null;
  remainingTimeIntervalId = -1;

  @action retryResolver = resolve => {
    this.retryResolve = resolve;
    this.retryTimeoutId = setTimeout(
      () => {
        this.retryTimeout *= 2;
        resolve();
      },
      this.retryTimeout,
    );
  };

  @action async wait(requestCallback) {
    if (this.retryPromise !== null) {
      await this.retryPromise;
      this.retryPromise = null;
    }
    try {
      const response = await requestCallback();
      this.retryTimeout = 15000;
      return response;
    } catch (error) {
      if (!(error.response && error.response.data)) {
        if (this.retryPromise === null) {
          this.retryPromise = new Promise(resolve => this.retryResolver(resolve));
          this.remainingTime = this.retryTimeout;
          this.remainingTimeIntervalId = setInterval(this.updateRemainingTime, 1000);
        }
        return await this.wait(requestCallback);
      }
      throw error;
    }
  }

  @action updateRemainingTime = () => {
    this.remainingTime -= 1000;
    if (this.remainingTime < 0) {
      this.remainingTime = null;
      clearInterval(this.remainingTimeIntervalId);
    }
  };

  forceRetry = () => {
    clearTimeout(this.retryTimeoutId);
    this.remainingTime = null;
    clearInterval(this.remainingTimeIntervalId);
    if (this.retryResolve) {
      this.retryResolve();
    }
  };
}


export default new FailedRequests();
